import {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import uuidV4 from 'uuid/v4';

export default class Radio extends Component {
    static propTypes = {
        /** Additional class(es) to add to the component. */
        className: PropTypes.string,
        /** The name for which the chosen value will correspond. Automatically passed from RadioGroup, do not set manually. */
        name: PropTypes.string,
        /** A value which is used when this radio is selected. */
        value: PropTypes.string,
        /** A custom label (typically a Label component) to display next to the radio. */
        label: PropTypes.string.isRequired,
        /** Whether the radio should be checked on mount. */
        defaultChecked: PropTypes.bool,
        /** Whether the element is disabled. Automatically passed from RadioGroup, do not set manually. */
        disabled: PropTypes.bool,
        /** Whether the element is required. Automatically passed from RadioGroup, do not set manually. */
        required: PropTypes.bool,
        hasInput: PropTypes.bool,
        /** The unique identifier to ensure this Radio is part of the right RadioGroup. Automatically passed from RadioGroup, do not set manually. */
        id: PropTypes.string,
        /**
         * Method called when an item is checked. Automatically passed from RadioGroup, do not set manually.
         *
         * @ignore
         */
        onChange: PropTypes.func,
        /**
         * Method called when validation state changes. Automatically passed from RadioGroup, do not set manually.
         *
         * @ignore
         */
        onValidationChange: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this._ID = `${props.id}-Radio-${uuidV4()}`;
    }

    componentDidMount() {
        this._input.addEventListener('invalid', this._onInvalid);
    }

    componentWillUnmount() {
        this._input.removeEventListener('invalid', this._onInvalid);
    }

    _onInvalid = evt => {
        evt.preventDefault();

        const {onValidationChange} = this.props;

        if (onValidationChange) {
            onValidationChange(evt.currentTarget.validity);
        }
    };

    _onChange = evt => {
        const {onValidationChange, onChange} = this.props;

        if (onValidationChange) {
            onValidationChange();
        }

        if (onChange) {
            onChange(evt);
        }
    };

    render() {
        const {
            label,
            className,
            name,
            value,
            defaultChecked,
            disabled,
            required,
            hasInput,
        } = this.props;
        const classes = classNames(
            'Radio',
            'FormElement',
            {'Radio-with-input': hasInput},
            className
        );

        return (
            <div className={classes}>
                <input
                    ref={node => {
                        this._input = node;
                    }}
                    className="FormElement-item"
                    id={this._ID}
                    type="radio"
                    name={name}
                    value={value}
                    defaultChecked={defaultChecked}
                    title={label}
                    aria-label={label}
                    onClick={this._onChange}
                    disabled={disabled}
                    required={required}
                    data-has-input={hasInput}
                />
                <label htmlFor={this._ID}>{label}</label>
            </div>
        );
    }
}
